<style lang="sass" rel="stylesheet/sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/compare
</style>

<template>
    <Zone
        :class="'g_' + $json.tabs.id"
        :dataLabel="$json.tabs.dataLabel"
        id="compare"
        class="g_light g_center"
        v-if="!$json.tabs.hide"
        auto-height>
        <Heading
            :level="2"
            v-html="$json.tabs.title" />
        <template slot="after">
            <Tabs
                :component="TabsTablesComponent"
                :componentStickyBar="StickyMenuBar"
                :id="$json.tabs.tabs.id"
                json-key="tabs" />
        </template>
    </Zone>
</template>

<script>
import Zone from 'gvue/src/core/Zone'
import Heading from 'gvue/src/core/Heading'
import Tabs from '../Tabs/Tabs'
import TabsTablesComponent from '../Tabs/components/TabsTablesComponent'
import StickyMenuBar from '../StickyMenuBar/StickyMenuBar'
// import StickySection from '../StickySection/StickySection'
export default {
    name: 'compare',
    components: {
        Zone,
        Heading,
        Tabs
    },
    data () {
        return {
            TabsTablesComponent,
            StickyMenuBar
        }
    }
}
</script>
